//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LibraryOnlineLogDisplayItem extends ItemBase {
    ID: string | null = null;
    LibraryOnlineItemID: string | null = null;
    ProfileID: string | null = null;
    ProfileName: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    Date: string = "1970-01-01T00:00:00";

    constructor(initializer?: Partial<LibraryOnlineLogDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryOnlineLogDisplayItem";
}
